import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators, NgForm } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DashboardService } from '../../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { applicationMessages, toasterMessages } from '@messages/*';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {
  @ViewChild('formDirective') formDirective: NgForm;

  admins: any[] = [];
  enterpriseId: string;
  currentUser: any;
  isLoading: boolean = false;

  roles: string[] = ['Super Admin', 'Admin'];
  rolesMap: { [key: string]: string } = {
    'Super Admin': 'ENTERPRISE_ADMIN',
    'Admin': 'ENTERPRISE_USER'
  };

  inviteEmailForm = this.fb.group({
    role: ['Admin', Validators.required],
    adminIds: ['', [
      Validators.required,
      Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)
    ]]
  });

  constructor(
    private dashboardService: DashboardService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.getProfile();
  }

  getProfile() {
    this.isLoading = true;
    this.dashboardService.getUserProfile().subscribe((res: any) => {
      this.currentUser = res;
      if (this.currentUser.role !== 'ENTERPRISE_ADMIN') {
        this.roles = ['Admin']; // Restricted access
      }
    });

    this.dashboardService.getAdminProfile().subscribe((res: any) => {
      this.isLoading = false;
      this.enterpriseId = res?._id;
      this.admins = res?.admins || [];
    }, () => {
      this.isLoading = false;
    });
  }

  inviteAdmins() {
    if (this.inviteEmailForm.invalid) return;

    const email = this.inviteEmailForm.value.adminIds.trim();
    const role = this.inviteEmailForm.value.role;
    const ids = { userType: this.rolesMap[role], emailId: email };

    this.isLoading = true;
    this.dashboardService.inviteAdmins(this.enterpriseId, ids).subscribe((res) => {
      this.toastr.success(toasterMessages.inviteAdminSuccess);

      this.dashboardService.clearAdminProfileCache(); // Clear cache to force refetch next time

      // Optimistic update
      this.admins.push({
        email: email,
        userType: this.rolesMap[role],
        role: this.rolesMap[role]
      });

      // Optional: Refresh from backend to be sure
      this.getProfile();

      this.formDirective.resetForm({ role: 'Admin', adminIds: '' });
    }, (err) => {
      this.isLoading = false;
      const errorMsg = err?.error?.errors?.[0]?.error || err?.error?.message || 'Failed to invite team member';
      this.toastr.error(errorMsg);
    });
  }

  deleteAdmin(admin: any, index: number) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'delete-dialog-container',
      data: { danger: true, messageBody: applicationMessages.adminDeleteConfirm }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        const ids = { emails: admin.email };
        this.dashboardService.unInviteAdmins(this.enterpriseId, ids).subscribe((res) => {
          this.toastr.success(toasterMessages.deleteAdminSuccess);
          this.admins.splice(index, 1);
        });
      }
    });
  }
}
